import React from 'react';

import { Chip } from '@mui/material';

const PaymentStatusChip = ({ status }) => {
    switch (status) {
        case 'INITIATED':
            return <Chip label="Initiated" color="default" size="small" />;
        case 'PENDING':
            return <Chip label="Pending" color="warning" size="small" />;
        case 'SETTLED':
            return <Chip label="Settled" color="success" size="small" />;
        case 'FAILED':
            return <Chip label="Failed" color="error" size="small" />;
        default:
            return <Chip label="Unknown" size="small" />;
    }
}

export default PaymentStatusChip;